import "../../../src/components/VGrid/VGrid.sass";
import Vue from 'vue';
import mergeData from '../../util/mergeData';
import { upperFirst } from '../../util/helpers';
const breakpoints = ['sm', 'md', 'lg', 'xl'];
const breakpointProps = (() => {
    return breakpoints.reduce((props, val) => {
        props[val] = {
            type: [Boolean, String, Number],
            default: false
        };
        return props;
    }, {});
})();
const offsetProps = (() => {
    return breakpoints.reduce((props, val) => {
        props['offset' + upperFirst(val)] = {
            type: [String, Number],
            default: null
        };
        return props;
    }, {});
})();
const orderProps = (() => {
    return breakpoints.reduce((props, val) => {
        props['order' + upperFirst(val)] = {
            type: [String, Number],
            default: null
        };
        return props;
    }, {});
})();
const propMap = {
    col: Object.keys(breakpointProps),
    offset: Object.keys(offsetProps),
    order: Object.keys(orderProps)
};
function breakpointClass(type, prop, val) {
    let className = type;
    if (val == null || val === false) {
        return undefined;
    }
    if (prop) {
        const breakpoint = prop.replace(type, '');
        className += `-${breakpoint}`;
    }
    if (type === 'col' && (val === '' || val === true)) {
        return className.toLowerCase();
    }
    className += `-${val}`;
    return className.toLowerCase();
}
const cache = new Map();
export default Vue.extend({
    name: 'v-col',
    functional: true,
    props: {
        cols: {
            type: [Boolean, String, Number],
            default: false
        },
        ...breakpointProps,
        offset: {
            type: [String, Number],
            default: null
        },
        ...offsetProps,
        order: {
            type: [String, Number],
            default: null
        },
        ...orderProps,
        alignSelf: {
            type: String,
            default: null,
            validator: str => ['auto', 'start', 'end', 'center', 'baseline', 'stretch'].includes(str)
        },
        tag: {
            type: String,
            default: 'div'
        }
    },
    render(h, { props, data, children, parent }) {
        let cacheKey = '';
        for (const prop in props) {
            cacheKey += String(props[prop]);
        }
        let classList = cache.get(cacheKey);
        if (!classList) {
            classList = [];
            let type;
            for (type in propMap) {
                propMap[type].forEach(prop => {
                    const value = props[prop];
                    const className = breakpointClass(type, prop, value);
                    if (className)
                        classList.push(className);
                });
            }
            const hasColClasses = classList.some(className => className.startsWith('col-'));
            classList.push({
                col: !hasColClasses || !props.cols,
                [`col-${props.cols}`]: props.cols,
                [`offset-${props.offset}`]: props.offset,
                [`order-${props.order}`]: props.order,
                [`align-self-${props.alignSelf}`]: props.alignSelf
            });
            cache.set(cacheKey, classList);
        }
        return h(props.tag, mergeData(data, {
            class: classList
        }), children);
    }
});
